import { subDays } from 'date-fns';

import type { Duration } from 'timezonecomplete';

import tc from '@/config/tc';
import { BLOCKS_IN_HOUR } from '@/config/variables';

const getDlsOffsetDiff = (dlsDay: Date, tz: string): number => {
  const start = dlsDay;
  const end = subDays(dlsDay, 1);

  const startTzOffset = tc?.instance()?.totalOffset(tz, start.getTime());
  const endTzOffset = tc?.instance()?.totalOffset(tz, end.getTime());

  const startAmount = startTzOffset?.amount() ?? 0;
  const endAmount = endTzOffset?.amount() ?? 0;
  if (endAmount === startAmount) return 0;
  return (startAmount - endAmount) * BLOCKS_IN_HOUR;
};

const getNextDST = (tz: string, utcMillis: number): number | undefined => tc.instance().nextDstChange(tz, utcMillis);

const getTimezoneAbbreviation = (tz: string, utcTime: number = Date.now()): string =>
  new Date(utcTime)
    .toLocaleTimeString('en-us', {
      timeZone: tz,
      timeZoneName: 'short',
    })
    .split(' ')[2];

const getTotalOffset = (tz: string, utcTime: number): Duration | null => tc?.instance()?.totalOffset(tz, utcTime);

export { getTimezoneAbbreviation, getNextDST, getDlsOffsetDiff, getTotalOffset };
